<template>
  <el-form
    ref="form"
    :label-position="labelPosition"
    :model="form"
    :rules="rulesComputed"
    label-width="100px"
    class="statrgy-manager-form"
  >
    <el-form-item
      label="策略渠道"
      prop="sourceType"
    >
      <el-radio-group
        v-model="form.sourceType"
        @change="sourceTypeChange"
      >
        <el-radio
          v-for="type in sourceTypeList"
          :label="type.key"
          :key="type.key"
        >{{ type.name }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      label="策略名称"
      prop="strategyName"
    >
      <el-input
        v-model="form.strategyName"
        placeholder="策略名称"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.sourceType==3"
      label="策略来源"
      prop="sourceId"
    >
      <el-input
        v-model="form.sourceId"
        placeholder="策略来源"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="策略来源"
      prop="sourceId"
      v-else
    >
      <el-select
        style="width: 100%"
        v-model="form.sourceId"
        clearable
        placeholder="策略来源"
        @change="sourceSelectChange"
      >
        <el-option
          v-for="item in strategySourceList"
          :key="item.appid"
          :label="getStrategySourceLable(item)"
          :value="getStrategySourceValue(item)"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="策略作者"
      prop="authorId"
    >
      <el-input
        v-if="form.sourceType >=3"
        v-model="form.authorId"
        placeholder="策略作者"
      ></el-input>
      <el-select
        v-else
        style="width: 100%"
        v-model="form.authorId"
        clearable
        placeholder="策略作者"
      >
        <el-option
          v-for="(item,index) in authorList"
          :key="index"
          :label="getAuthorLable(item)"
          :value="getAuthorValue(item)"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="超时时间"
      prop="expirePeriod"
    >
      <el-input
        v-model="form.expirePeriod"
        placeholder="超时时间"
      >
        <template slot="append">分钟</template>
      </el-input>
    </el-form-item>
    <el-form-item
      label="匹配规则"
      prop="matchMode"
    >
      <el-radio-group
        v-model="form.matchMode"
      >
        <el-radio
          v-for="type in matchModeList"
          :label="type.key"
          :key="type.key"
        >{{ type.name }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      v-if="form.matchMode==2"
      label="正则表达式"
      prop="pattern"
    >
      <el-input
        v-model="form.pattern"
        placeholder="正则表达式"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="策略备注"
      prop="remark"
    >
      <el-input
        v-model="form.remark"
        placeholder="策略备注"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="状态"
      prop="status"
    >
      <el-radio-group
        v-model="form.status"
      >
        <el-radio
          v-for="type in statusList"
          :label="type.key"
          :key="type.key"
        >{{ type.name }}</el-radio>
      </el-radio-group>
    </el-form-item>
  </el-form>
</template>

<script>
import formLabalPosition from "@/mixins/formLabalPosition";
import quillEditor from "@/components/public/quillEditor";
import ossUploader from "@/components/public/ossUploader";
import {
  queryPersonalWxBotList,
  queryPersonalWxFriendsList, queryReptileStrategyList,
  queryWxPublicAccountFansList,
  queryWxPublicAccountList
} from "@/api/sys/statrgyManager/statrgyManager";
let origin = {
  sourceType: 1,
  strategyName: '',
  sourceId: '',
  authorId: '',
  expirePeriod: '',
  matchMode: 1,
  pattern: '',
  remark: '',
  status: 1,
}
export default {
  name: "statrgyArticleForm",
  components: {
    quillEditor,
    ossUploader,
  },
  props: {
    formData:{
      type: Object,
      default(){
        return {
          id: ''
        };
      }
    }
  },
  mixins: [formLabalPosition],
  data() {
    let _this = this;
    return {
      sourceTypeList:[
        {key:1,name:'微信公众号'},
        {key:2,name:'个人微信'},
        {key:3,name:'Webhook'},
        {key:4,name:'其他(爬虫)'}
      ],
      //策略来源 1.微信公众号列表 2个人微信机器人列表 3个人微信好友列表 4 爬虫策略列表
      wxPublicAccountList: [],//微信公众号列表
      personalWxBotList: [],//个人微信机器人列表
      reptileStrategyList: [],//爬虫策略列表
      //作者来源列表
      wxPublicAccountFansList: [],//微信公众号粉丝列表,属于作者列表
      personalWxFriendsList: [],//个人微信好友列表,属于作者列表
      matchModeList:[
        {key:1,name:'无需匹配'},
        {key:2,name:'正则匹配'}
      ],
      statusList:[
        {key:1,name:'启用'},
        {key:0,name:'禁用'}
      ],
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
        sourceType: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        strategyName: [
          { required:true, message: '请输入', trigger: 'blur'},
        ],
        sourceId: [
          _this.sourceIdRule,
        ],
        authorId: [
          _this.authIdRule,
        ],
        /* expirePeriod: [
           { required:true, message: '请输入', trigger: 'blur' },
         ],*/
        /* matchMode: [
           { required:true, message: '请选择', trigger: 'change' },
         ],*/
        /*pattern: [
          { required:true, message: '请选择', trigger: 'change' },
        ],*/
        /*remark: [
          { required:true, message: '请选择', trigger: 'change' },
        ],*/
        /*status: [
          { required:true, message: '请选择', trigger: 'change' },
        ]*/
      },
    }
  },
  computed: {
    strategySourceList() {
      switch (this.form.sourceType){
        case 1:
          // 微信公众号列表
          return this.wxPublicAccountList;
        case 2:
          // 个人微信机器人列表
          return this.personalWxBotList;
        case 4:
          // 爬虫策略列表
          return this.reptileStrategyList;
      }
    },
    authorList(){
      switch (this.form.sourceType){
        case 1:
          // 微信公众号粉丝列表
          return this.wxPublicAccountFansList;
        case 2:
          // 个人微信好友列表
          return this.personalWxFriendsList;
      }
    },
    authIdRule(){
      if(this.form.sourceType >= 3){
        return { required: true, message: '请完成', trigger: 'blur',}
      }else {
        return { required:true, message: '请完成', trigger: 'change',}
      }
    },
    sourceIdRule(){
      if(this.form.sourceType == 3){
        return { required:true, message: '请完成', trigger: 'blur'};
      }else {
        return { required:true, message: '请完成', trigger: 'change'};
      }
    },
    rulesComputed(){
      return {
        sourceType: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        strategyName: [
          { required:true, message: '请输入', trigger: 'blur'},
        ],
        sourceId: [
          this.sourceIdRule,
        ],
        authorId: [
          // this.authIdRule,
        ],
        /* expirePeriod: [
           { required:true, message: '请输入', trigger: 'blur' },
         ],*/
        /* matchMode: [
           { required:true, message: '请选择', trigger: 'change' },
         ],*/
        /*pattern: [
          { required:true, message: '请选择', trigger: 'change' },
        ],*/
        /*remark: [
          { required:true, message: '请选择', trigger: 'change' },
        ],*/
        /*status: [
          { required:true, message: '请选择', trigger: 'change' },
        ]*/
      }
    },
  },
  watch:{
    formData:{
      handler(newValue){
        if(newValue.id){
          this.assigen(newValue);
        }
      },
      deep: true,
    },
    'form.sourceType'(newValue){


    }
  },

  created(){
    this.getWxPublicAccountList();

    this.getPersonalWxBotList();
    this.getReptileStrategyList();

    //作者列表
    this.getWxPublicAccountFansList();

  },
  methods: {
    getStrategySourceLable(item){
      switch (this.form.sourceType){
        case 1:
          // 微信公众号列表
          return item.name;
        case 2:
          // 个人微信机器人列表
          return item.nickname;
        case 4:
          // 爬虫策略列表
          return item;
      }
    },
    getStrategySourceValue(item){
      switch (this.form.sourceType){
        case 1:
          // 微信公众号列表
          return item.appid;
        case 2:
          // 个人微信机器人列表
          return item.id;
        case 4:
          // 爬虫策略列表
          return item;
      }
    },
    getAuthorLable(item){
      switch (this.form.sourceType){
        case 1:
          // 微信公众号粉丝列表
          return item.nickname;
        case 2:
          // 个人微信好友列表
          return item.nickname;
      }
    },
    getAuthorValue(item){
      switch (this.form.sourceType){
        case 1:
          // 微信公众号粉丝列表
          return item.openid;
        case 2:
          // 个人微信好友列表
          return item.id;
      }
    },
    //微信公众号列表
    getWxPublicAccountList(){
      queryWxPublicAccountList().then((res) => {
        console.log('公众号列表',res);
        this.wxPublicAccountList = res.page.list;
      })
    },
    //微信公众号粉丝列表this.form.sourceId
    getWxPublicAccountFansList(){
      queryWxPublicAccountFansList({
        page: 1,
        limit: 1000,
        appId: this.form.sourceType,
      }).then((res) => {
        if (res.code === 200) {

          this.wxPublicAccountFansList = res.page.list;
        } else {
          this.wxPublicAccountFansList = [];
        }
      })
    },
    //个人微信好友列表
    getPersonalWxFriendsList(){
      //逻辑有点问题,需要重新整理  todo
      queryPersonalWxFriendsList({
        page: 1,
        limit: 1000,
        botId: this.form.sourceId,
      }).then((res) => {
        console.log('个人微信好友列表',res.page.list);
        if(res.code === 200){
          this.personalWxFriendsList = res.page.list;
          console.log('个人微信好友列表this.data',this.personalWxFriendsList);
        }else {
          this.personalWxFriendsList = [];
        }
        console.log('personalWxFriendsList',this.personalWxFriendsList);
      })
    },
    sourceSelectChange(value){
      this.form.authorId = '';
      this.$refs.form.clearValidate(['authorId']);
      this.getPersonalWxFriendsList();
    },
    //个人微信机器人列表
    getPersonalWxBotList(){
      queryPersonalWxBotList({
        page: 1,
        limit: 1000,
        botStatus: 1,
      }).then((res) => {
        this.personalWxBotList = res.page.list;
      });
    },
    //爬虫策略列表
    getReptileStrategyList(){
      queryReptileStrategyList().then((res) => {
        if (res && res.code === 200) {
          this.reptileStrategyList = res.sourceNames;

        } else {
          this.reptileStrategyList=[]
        }
      })
    },
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
    },
    assigen(data){
      // todo
      this.form.id = data.id;
      this.form = {
        ...data,
      };
      this.getWxPublicAccountFansList();
      this.getPersonalWxFriendsList();
    },
    // 菜单树设置当前选中节点
    // 上级菜单有时候编辑的时候没有对得上,有点问题, todo

    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          if(!this.form.authorId){
            this.$message.error('请输入或者选择策略作者');
            return;
          }
          this.$emit('submit',this.form);
        }else {
          console.log('no-pass');
        }
      })
    },
    selfClear(){
      this.$refs.form.resetFields();
      this.$refs.form.clearValidate();
      this.reset();
    },
    catchData(content){
      this.form.contentEdit = content;
    },
    sourceTypeChange(){
      this.form.sourceId = '';
      if(this.form.sourceType < 3){
        this.form.authorId = '';
      }
      if(this.form.sourceType !== 3 ) {
        this.getWxPublicAccountFansList();
      }
      this.$refs.form.clearValidate();
    }
  },
}
</script>

<style lang="scss" scoped>
.statrgy-manager-form {
  /deep/ .el-radio-group {
    padding-top: 15px;
    display: flex;
    justify-content: start;
    align-items: center;
    flex-wrap: wrap;
    .el-radio {
      margin-bottom: 10px;
    }
  }
}
</style>
